import { requestV2 } from "../../helpers/request";

const baseEndpoint = "/maintenance/realEstateGroups";
const pathCustomFields = "/customFields";

export async function getCustomFields(realEstateGroupId) {
  return requestV2({
    endpoint: `${baseEndpoint}/${realEstateGroupId}${pathCustomFields}`,
    defaultResponse: []
  });
}

export async function createCustomField(realEstateGroupId, data) {
  return requestV2({
    endpoint: `${baseEndpoint}/${realEstateGroupId}${pathCustomFields}/add`,
    bodyRequest: data,
    defaultResponse: {}
  });
}

export async function updateCustomField(
  realEstateGroupId,
  customFieldId,
  data
) {
  return requestV2({
    endpoint: `${baseEndpoint}/${realEstateGroupId}${pathCustomFields}/${customFieldId}/update`,
    bodyRequest: data,
    defaultResponse: {}
  });
}

export async function deleteCustomField(realEstateGroupId, customFieldId) {
  return requestV2({
    endpoint: `${baseEndpoint}/${realEstateGroupId}${pathCustomFields}/${customFieldId}/remove`,
    defaultResponse: {}
  });
}
